import React from 'react'
import { BrowserRouter, Navigate, Route, Router, Routes } from 'react-router-dom';
import RequireAuth from '../RequireAuth';
import AppLayout from '../AppLayout';
import MilmaAdminSidebar from '../sidebars/MilmaAdminSidebar';
import MilmaAdminUserDashboard from '../milma-admin/MilmaAdminUserDashboard';
import FranchiseesPage from '../milma-admin/franchisees/FranchiseesPage';
import NewFranchiseePage from '../milma-admin/franchisees/NewFranchiseePage';
import PermissionsPage from '../milma-admin/permissions/PermissionsPage';
import NewPermissionPage from '../milma-admin/permissions/NewPermissionPage';
import EditPermissionPage from '../milma-admin/permissions/EditPermissionPage';
import RolesPage from '../milma-admin/roles/RolesPage';
import NewRolePage from '../milma-admin/roles/NewRolePage';
import EditRolePage from '../milma-admin/roles/EditRolePage';
import MilmaAdminsPage from '../milma-admin/milmaAdmin/MilmaAdminsPage';



const MilmaAdminRoutes = () => {
  return (
    <Routes>

        
     

     


  
      <Route
        exact path="/home"
        element={
          <RequireAuth>
            <AppLayout sidebar={<MilmaAdminSidebar />}>
              <MilmaAdminUserDashboard />
            </AppLayout>
          </RequireAuth>
        }
      /> 
      <Route
        exact path="/franchisees"
        element={
          <RequireAuth>
            <AppLayout sidebar={<MilmaAdminSidebar />}>
              <FranchiseesPage />
            </AppLayout>
          </RequireAuth>
        }
      />

        <Route
        path="/franchisees/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<MilmaAdminSidebar />}>
              <NewFranchiseePage/>
            </AppLayout>
          </RequireAuth>
        }
      />

       {/* <Route
        path="/franchisees/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<MilmaAdminSidebar />}>
              <EditSalesInvoicePage/>
            </AppLayout>
          </RequireAuth>
        }
      />
      */}


       <Route
        path="/permissions"
        element={
          <RequireAuth>
            <AppLayout sidebar={<MilmaAdminSidebar />}>
              <PermissionsPage />
            </AppLayout>
          </RequireAuth>
        }
      />

          <Route
        path="/permissions/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<MilmaAdminSidebar />}>
              <NewPermissionPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/permissions/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<MilmaAdminSidebar />}>
              <EditPermissionPage />
            </AppLayout>
          </RequireAuth>
        }
      />




      <Route
        path="/roles"
        element={
          <RequireAuth>
            <AppLayout sidebar={<MilmaAdminSidebar />}>
              <RolesPage />
            </AppLayout>
          </RequireAuth>
        }
      />

          <Route
        path="/roles/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<MilmaAdminSidebar />}>
              <NewRolePage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/roles/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<MilmaAdminSidebar />}>
              <EditRolePage />
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/managers"
        element={
          <RequireAuth>
            <AppLayout sidebar={<MilmaAdminSidebar />}>
              <MilmaAdminsPage />
            </AppLayout>
          </RequireAuth>
        }
      />
       
    </Routes>
  )
}

export default MilmaAdminRoutes
